const TestActionTypes = {
  INCREASE_VALUE: "INCREASE_VALUE",
  DECREASE_VALUE: "DECREASE_VALUE",
};

export default TestActionTypes;
